import React, { useState, useCallback } from "react";
import FormSkel from "../../../../../components/Modals/FormSkel";

const ConfirmRestartForm = ({ isOpen, onClose, onSubmit, generateTaskId }) => {
  const [startAt, setStartAt] = useState("");

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const task = {
      id: generateTaskId(),
      taskType: "RESTART",
      startAt: startAt || null,
      datetimeType: startAt ? "single" : null,
    };
    
    onSubmit(task);
    setStartAt("");
  }, [startAt, onSubmit, generateTaskId]);

  const handleClose = useCallback(() => {
    setStartAt("");
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <FormSkel
      headerText="Potwierdź zdalny restart automatu"
      handleClose={handleClose}
      acceptForm="true"
      customName="Zrestartuj"
      warning={true}
    >
      <div>
        <form onSubmit={handleSubmit} id="modal-form">
          <div className="form-group">
            <div className="alert alert-warning border-warning shadow-sm" role="alert">
              <div className="d-flex align-items-center mb-2">
                <strong className="h6 mb-0 text-dark">Uwaga! Ostrzeżenie dotyczące restartu</strong>
              </div>
              <p className="mb-0 small text-dark">
                Jeżeli automat znajduje się w trakcie transakcji lub wydawania produktu, 
                zdalny restart może spowodować przerwane wydanie i zablokowanie automatu.
              </p>
            </div>
            <p className="text-danger font-weight-bold text-center my-3">
              Czy na pewno chcesz zlecić restart maszyny?
            </p>
          </div>
          
          <div className="form-group mb-0">
            <label htmlFor="datetimeRestart" className="form-label font-weight-bold">
              Kiedy wykonać restart (opcjonalnie)
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="datetimeRestart"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
            <small className="form-text text-muted">
              Pozostaw puste dla natychmiastowego wykonania.
            </small>
          </div>
        </form>
      </div>
    </FormSkel>
  );
};

export default ConfirmRestartForm;
